import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { IProjectsListType } from "../../../../@types/project/project.type";
import { toast } from "react-toastify";
import { getAllProjectsAndPositionByResourceId } from "../../../../services/api/projects/projectService";
import styles from "./styles.module.scss";

interface ProjectListProps {
  id?: string | null | undefined;
}

interface ProjectPaperProps {
  projectName?: string;
  position?: string;
}

const ProjectPaper: React.FC<ProjectPaperProps> = ({
  projectName = "",
  position = "",
}) => {
  return (
    <Paper className={styles.projectPaper}>
      <div className={styles.projectName}>{projectName}</div>
      <div className={styles.projectPosition}>{position}</div>
    </Paper>
  );
};

export const ProjectList: React.FC<ProjectListProps> = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState<IProjectsListType[]>([]);
  async function fetchProjectsByResourceId() {
    try {
      setLoading(true);
      const responseProjects = await getAllProjectsAndPositionByResourceId(id);
      setProjects(responseProjects);
      console.log(projects);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar os projetos do colaborador!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (id != undefined && id != null) {
      fetchProjectsByResourceId();
    }
  }, [id]);

  return (
    <Grid container spacing={2} className={styles.projectGridContainer}>
      {projects && projects.length > 0 ? (
        projects.map((project) => (
          <Grid
            item
            xs={12}
            sm={projects.length === 1 ? 12 : 6}
            key={project.projectId}
            className={styles.projectGridItem}
          >
            <ProjectPaper
              projectName={project.projectName}
              position={project.positionName}
            />
          </Grid>
        ))
      ) : (
        <Grid
          item
          xs={12}
          className={styles.projectGridItem}
          style={{ textAlign: "center" }}
        >
          <ProjectPaper
            projectName="Este colaborador não está associado a nenhum projeto"
            position="É possível associar um projeto ao colaborador no mapa de alocação"
          />
        </Grid>
      )}
    </Grid>
  );
};
